import { useState } from 'react'
import { Mail, ArrowRight, Check } from 'lucide-react'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  Button,
  cn,
} from '@wove/web-ui'

export function EmailIntegration() {
  const [isConnecting, setIsConnecting] = useState(false)
  const [isConnected, setIsConnected] = useState(false)

  const handleConnect = () => {
    setIsConnecting(true)

    // Simulate connection process
    setTimeout(() => {
      setIsConnecting(false)
      setIsConnected(true)
    }, 2000)
  }

  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle>Email Copilot</CardTitle>
        <CardDescription>Connect your email to automate logistics workflows</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center space-y-4 text-center">
        <div
          className={cn(
            'rounded-full p-4 transition-all duration-500',
            isConnecting
              ? 'bg-blue-100 animate-pulse'
              : isConnected
              ? 'bg-green-100'
              : 'bg-primary/10',
          )}
        >
          {isConnected ? (
            <Check className="h-8 w-8 text-green-600 animate-in zoom-in duration-300" />
          ) : (
            <Mail
              className={cn(
                'h-8 w-8 transition-all duration-300',
                isConnecting ? 'text-blue-500 animate-spin' : 'text-primary',
              )}
            />
          )}
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">
            {isConnected ? 'Email Connected!' : 'Streamline Your Workflow'}
          </h3>
          <p className="text-sm text-muted-foreground">
            {isConnected
              ? 'Your email copilot is now ready to automate your logistics workflows'
              : 'Connect your email client to automate RFQs, customs, and tariff management'}
          </p>
        </div>
      </CardContent>
      <CardFooter>
        <Button
          className={cn(
            'w-full transition-all duration-300',
            isConnecting && 'bg-blue-600',
            isConnected && 'bg-green-600',
          )}
          disabled={isConnecting || isConnected}
          onClick={handleConnect}
        >
          {isConnecting ? (
            <>Connecting...</>
          ) : isConnected ? (
            <>
              Connected <Check className="ml-2 h-4 w-4" />
            </>
          ) : (
            <>
              Connect Email Copilot
              <ArrowRight className="ml-2 h-4 w-4" />
            </>
          )}
        </Button>
      </CardFooter>
    </Card>
  )
}
